import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { LuX } from "react-icons/lu";

export function ActionBar({
  children,
  className,
  centered = true,
  stickyBottom = true,
}: any) {
  return (
    <Card
      className={cn(
        "max-w-full h-[70px] z-50 drop-shadow-lg flex items-center justify-between px-7 space-x-2",
        centered && "left-1/2 transform -translate-x-1/2",
        stickyBottom && "fixed bottom-3",
        className,
      )}
    >
      {children}
    </Card>
  );
}

export function RowsSelected({
  totalRowsLength,
  selectedRowsLength,
  onDeselectAll,
}: {
  totalRowsLength: number;
  selectedRowsLength: number;
  onDeselectAll: () => void;
}) {
  return (
    <div className="flex">
      <Button
        variant="outline"
        onClick={onDeselectAll}
        className="border-gray-300 border-dashed text-gray-500"
      >
        {selectedRowsLength} von {totalRowsLength}
        {selectedRowsLength > 0 && <LuX className="h-5 w-5 ml-2" />}
      </Button>
    </div>
  );
}
